// src/hooks/useMapLayerPrefs.js
// Live Map overlay-layer toggles (traffic / aircraft / liveuamap).
// MODULE-scope shared state: consumed by MapLayersControl (writer), MapView
// (traffic visibility), AircraftOverlay and LiveuamapOverlay (pollers) — a
// per-instance useState would desync them (src/CLAUDE.md multi-consumer rule).
import { useEffect, useReducer } from 'react';

const STORAGE_KEY = 'trackizy_livemap_layers';
const DEFAULTS = { cluster: true, traffic: false, aircraft: false, liveuamap: false };

function load() {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') };
  } catch {
    return { ...DEFAULTS };
  }
}

let state = load();
const listeners = new Set();
const notify = () => listeners.forEach((l) => l());

export function setLayerEnabled(key, enabled) {
  state = { ...state, [key]: Boolean(enabled) };
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch { /* ignore */ }
  notify();
}

export function getLayerPrefs() {
  return state;
}

export default function useMapLayerPrefs() {
  const [, force] = useReducer((n) => n + 1, 0);
  useEffect(() => {
    listeners.add(force);
    return () => listeners.delete(force);
  }, []);
  return { layers: state, setLayerEnabled };
}
